function filenameToLabel(fn) {
    if (fn.indexOf("/") >= 0) {
        return fn.split("/")
            .map(filenameToLabel)
            .join(" / ")
            .trim();
    }
    if (fn.substr(fn.length - 4) === ".txt") {
        fn = fn.substr(0, fn.length - 4);
    }
    if (/^[A-Z]{2,}-[0-9]+(-|$)/.test(fn)) {
        // don't touch JIRA ticket numbers
        const parts = fn.split("-");
        if (parts.length === 2) return fn;
        return parts[0] + "-" + parts[1]
            + " "
            + filenameToLabel(parts.slice(2).join("-"));
    }
    fn = fn.replace(/[-_]+/g, " ");
    const parts = [];
    let buffer = "";
    for (let i = 0; i < fn.length; i++) {
        const first = i === 0;
        const last = i === fn.length - 1;
        let nextUpper = false;
        let prevUpper = false;
        let prevNumeric = false;
        if (! last) {
            const n = fn.charAt(i + 1);
            nextUpper = n >= "A" && n <= "Z";
        }
        if (! first) {
            const p = fn.charAt(i - 1);
            prevUpper = p >= "A" && p <= "Z";
            prevNumeric = p >= "0" && p <= "9";
        }
        const c = fn.charAt(i);
        if (c >= "A" && c <= "Z") {
            if (!prevUpper) {
                parts.push(buffer);
                buffer = "";
            }
            if (nextUpper || (prevUpper && last)) {
               buffer += c;
            } else {
                parts.push(buffer);
                buffer = c.toLowerCase();
            }
        } else if (c >= "a" && c <= "z") {
            if (prevNumeric) {
                parts.push(buffer);
                buffer = c;
            } else {
                buffer += c;
            }
        } else if (c >= "0" && c <= "9") {
            if (prevNumeric) {
                buffer += c;
            } else {
                parts.push(buffer);
                buffer = c;
            }
        } else {
            buffer += c;
        }
    }
    parts.push(buffer);
    return parts
        .map(it => it.trim())
        .filter(it => it)
        .join(" ");
}

export default filenameToLabel;



// WEBPACK FOOTER //
// ./app/lib/filenameToLabel.js